const oevo = {
  siegel: ['https://www.oeffentlicheoldenburg.de/export/sites/oevo/_resources/bilder/siegel/tarifrechner_siegel1.png'],
  prepage: {
    headline: 'Die Hausratversicherung der Öffentlichen - Alles drin, was wichtig ist',
    leistungen: [
      'So individuell wie Ihr Zuhause',
      'Absicherung von Schäden an Einrichtungs- und Gebrauchsgegenständen',
      'Ersatz zum Neuwert',
    ],
  },
  erstedaten: {
    headline: 'In wenigen Schritten zu Ihrer Hausratversicherung',
    frageHabenSieBereitsHausrat: 'Haben Sie bereits eine Hausratversicherung bei den Öffentlichen Versicherungen Oldenburg?',
    typ_tt: `<h2>Wohnung oder Haus?</h2>
        <p>Geben Sie hier bitte an, ob Sie den Hausrat in einer Wohnung oder einem Haus versichern möchten.</p>
        <p>Wenn das Haus oder die Wohnung nicht dauerhaft bewohnt sind, lassen Sie sich bitte <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort beraten</a>.</p>`,
    versbeginn_tt: `<h2>Versicherungsbeginn</h2>
        <p>Geben Sie hier bitte an, wann der Versicherungsschutz beginnen soll.</p>`,
  },
  footertext: `<h2 class="h5">Beitragsberechnung zur Hausratversicherung</h2>
    <p><strong>Mit dem Beitragsrechner zur Hausratversicherung der Öffentlichen Oldenburg berechnen Sie in wenigen Sekunden, was die Versicherung für Ihren Hausrat, also Ihr Hab und Gut, kostet.</strong> 
    Nach der Beantwortung weniger Fragen erfahren Sie sofort Ihren Versicherungsbeitrag und können direkt online abschließen.</p>
    <p>Die Hausratversicherung der <strong>Öffentlichen Oldenburg</strong> ist die richtige Wahl für alle, die ihren "Wohnungsinhalt" oder die Einrichtung Ihres Hauses absichern wollen 
    Mit unserer langjährigen Erfahrung wissen wir, worauf es ankommt. Ihr Hausrat ist bei uns in den besten Händen.
    Mit den starken Leistungen der Hausratversicherung ist Ihr Hab und Gut bestens geschützt.</p>
    <p>Mit unseren Zusatzbausteinen können Sie den Versicherungsschutz individuell gestalten und zum Beispiel den Schutz vor Naturgefahren (Elementarschäden) einschließen.</p>
    <p>Profitieren Sie von starken Leistungen: Wir leisten bei Schäden für die Reparatur oder Neuanschaffung einschließlich Preissteigerungen und Folgekosten. 
    Mit der Außenversicherung sind Ihre Sachen auf Reisen versichert. Auf Wunsch sind zudem Schäden durch grobe Fahrlässigkeit oder der Diebstahl in Schule oder am Arbeitsplatz eingeschlossen.</p>`,
  produktvergleich: {
    Basis: {
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h2>Wertsachen</h2>
          <ul class="list-icn-checkbullet">
          <li>Wertsachen sind insgesamt bis zu einer Höhe von 20&nbsp;% der Versicherungssumme mitversichert.*</li>
          <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 2.500&nbsp;€ versichert.</li>
          <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 5.000&nbsp;€ versichert.</li>
          <li>Schmucksachen, Uhren, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold 
          oder Platin sind bis maximal 25.000&nbsp;€ versichert.</li>
          </ul>
          <p class="mini">
            <strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong>
          </p>
          $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_footer: `<p>Bitte wenden Sie sich an Ihren <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">Ansprechpartner vor Ort</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>`,
        wertsachen_footer_spk: '<p>Bitte sprechen Sie uns an, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
      leistungen: {
        neuwert: 'Neuwertversicherung',
        feuer: 'Feuer',
        einbruch: 'Einbruch und Beraubung',
        vandalismus: 'Vandalismus',
        sturm: 'Sturm, Hagel und Leitungswasser',
        aussen: 'Außenversicherung bis 20.000&nbsp;€',
      },
      leistungenTooltips: {
        aussen: `<h2>Außenversicherung bis 20.000 €</h2>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend, längstens für 3 Monate, außerhalb des Versicherungsortes – 
        also der Wohnung oder des Hauses – befinden. Wir erstatten bis zu 20&nbsp;% der Versicherungssumme, maximal 20.000&nbsp;€.</p>`,
      },
      keineLeistungen: {
        blitz: 'Blitzüberspannung',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit',
        auto: 'Diebstahl aus dem Auto',
        garten: 'Schäden an Gartenmöbeln und -inventar',
        arbeitsplatz: 'Diebstahl am Arbeitsplatz oder in der Schule',
      },
    },
    Komfort: {
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h2>Wertsachen</h2>
          <ul class="list-icn-checkbullet">
          <li>Wertsachen sind insgesamt bis zu einer Höhe von 30&nbsp;% der Versicherungssumme mitversichert.*</li>
          <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 5.000&nbsp;€ versichert.</li>
          <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 10.000&nbsp;€ versichert.</li>
          <li>Schmucksachen, Uhren, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold oder 
          Platin sind bis maximal 50.000&nbsp;€ versichert.</li>
          </ul>
          <p class="mini">
            <strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong>
          </p>
          $t(produktvergleich.Komfort.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_footer: `<p>Bitte wenden Sie sich an Ihren <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">Ansprechpartner vor Ort</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>`,
        wertsachen_footer_spk: '<p>Bitte sprechen Sie uns an, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
      leistungen: {
        neuwert: 'Neuwertversicherung',
        feuer: 'Feuer',
        einbruch: 'Einbruch und Beraubung',
        vandalismus: 'Vandalismus',
        sturm: 'Sturm, Hagel und Leitungswasser',
        aussen: 'Außenversicherung bis 30.000&nbsp;€',
        blitz: 'Blitzüberspannung',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit bis 10.000&nbsp;€',
      },
      leistungenTooltips: {
        aussen: `<h2>Außenversicherung</h2>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend, längstens für 6 Monate, außerhalb des Versicherungsortes – 
        also der Wohnung oder des Hauses – befinden. Wir erstatten bis zu 30&nbsp;% der Versicherungssumme, maximal 30.000&nbsp;€.</p>
        <p>In der Basisdeckung ist die Entschädigung auf 20&nbsp;% der Versicherungssumme, maximal 20.000&nbsp;€ begrenzt.</p>`,
      },
      keineLeistungen: {
        auto: 'Diebstahl aus dem Auto',
        garten: 'Schäden an Gartenmöbeln und -inventar',
        arbeitsplatz: 'Diebstahl am Arbeitsplatz oder in der Schule',
      },
    },
    Premium: {
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h2>Wertsachen</h2>
          <ul class="list-icn-checkbullet">
          <li>Wertsachen sind insgesamt bis zu einer Höhe von 40&nbsp;% der Versicherungssumme mitversichert.*</li>
          <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 5.000&nbsp;€ versichert.</li>
          <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 10.000&nbsp;€ versichert.</li>
          <li>Schmucksachen, Uhren, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold oder Platin sind bis maximal 50.000&nbsp;€ versichert.</li>
          </ul>
          <p class="mini">
            <strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong>
          </p>
          $t(produktvergleich.Premium.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_footer: `<p>Bitte wenden Sie sich an Ihren <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">Ansprechpartner vor Ort</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>`,
        wertsachen_footer_spk: '<p>Bitte sprechen Sie uns an, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
      leistungen: {
        neuwert: 'Neuwertversicherung',
        feuer: 'Feuer',
        einbruch: 'Einbruch und Beraubung',
        vandalismus: 'Vandalismus',
        sturm: 'Sturm, Hagel und Leitungswasser',
        aussen: 'Außenversicherung bis 30.000&nbsp;€',
        blitz: 'Blitzüberspannung',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit bis {{VSU}}&nbsp;€',
        auto: 'Diebstahl aus dem Auto',
        garten: 'Schäden an Gartenmöbeln und -inventar',
        arbeitsplatz: 'Diebstahl am Arbeitsplatz oder in der Schule',
      },
      leistungenTooltips: {
        aussen: `<h2>Außenversicherung</h2>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend außerhalb, längstens für 6 Monate, des Versicherungsortes – 
        also der Wohnung oder des Hauses – befinden. Wir erstatten bis zu 30&nbsp;% der Versicherungssumme, maximal 30.000&nbsp;€.</p>
        <p>In der Basisdeckung ist die Entschädigung auf 20&nbsp;% der Versicherungssumme, maximal 20.000&nbsp;€ begrenzt.</p>`,
      },
    },
    produkte: {
      vsu_flaeche: '700',
      neuwert: `<h4>Neuwertversicherung</h4>
        <p>Wir ersetzen Ihren Hausrat zum Neuwert, wenn die beschädigten oder zerstörten Sachen nicht repariert werden können. Dabei spielt der ursprüngliche Anschaffungspreis keine Rolle. 
           Sie erhalten im Schadenfall immer den Betrag, der zur Wiederbeschaffung oder Reparatur "in gleicher Art und Güte" notwendig ist. Und sollte nach einer Reparatur eine Wertminderung 
           bleiben, gleichen wir diese ebenfalls aus.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrichtungsgegenstände, Gebrauchsgegenstände wie Kleidung, aber auch Verbrauchsgüter 
        (z. B. Essen) und Wertsachen.</p>`,
      auto: `<h4>Diebstahl aus dem verschlossenen Kfz</h4>
        <p>Diebstahl von Hausrat aus dem verschlossenen Kfz, Wohnmobil, Wohnwagen, verschlossenen Kraftfahrzeugkofferanhänger oder aus Dachgepäckboxen beziehungsweise Motorradkoffern 
        sowie Wassersportfahrzeugen ist innerhalb Europas (im geografischen Sinn) bis 5.000&nbsp;€ versichert.</p>`,
    },
    zusatz: {
      naturgefahren_beschreibung: `
        <p class="mb-2">Zum Schutz bei Elementar­schäden wie Stark­regen, Hoch­wasser oder Schnee­druck.</p>
      `,
      naturgefahren_tt: `<h2>Schutz vor Naturgefahren</h2>
        <p>Die Versicherung gegen erweiterte Naturgefahren (Elementarschäden) ist eine Zusatzversicherung, die Ihr Zuhause vor Schäden durch Naturkatastrophen schützt. <br/>
        Machen Sie Ihr Haus wetterfest und schützen Sie sich mit diesem Zusatzbaustein vor den immensen Kosten durch:</p>
        <ul class="list-icn-checkbullet">
          <li>Überschwemmungen durch Hochwasser an Flüssen, Seen, Teichen oder Bächen, welche beispielsweise durch Regen oder Schneeschmelze verursacht werden.<br/>
              (Ausnahmen: Überschwemmungen/ Gewässerrückstau durch Sturmflut oder Grundwasseranstieg)</li>
          <li>Schäden infolge Hochwasser durch zurückgestaute Wassermassen, die durch die Kanalisation in das Gebäude eindringen (Rückstau)</li>
          <li>Schäden durch die naturbedingte Erschütterung des Erdbodens</li>
          <li>Schäden durch Einsturz des Erdbodens über natürlichen Hohlräumen (z. B. unterirdischen Höhlen)</li>
          <li>Schäden durch naturbedingte Abgleitung oder Absturz von Gesteins- oder Erdmassen</li>
          <li>Schäden durch die Wirkung des Gewichtes von Schnee- und Eismassen</li>
          <li>Schäden durch an Berghängen niedergehende Schnee- oder Eismassen</li>
          <li>Schäden durch Lavaergüsse, Asche- oder Gesteinseruptionen</li>
        </ul>`,
      naturgefahren_sb_label: 'Selbstbeteiligung für Naturgefahren',
      naturgefahren_sb_tt: `<h2>Selbstbeteiligung für erweiterte Naturgefahren (Elementarschäden)</h2>
      <p>Wenn Sie eine höhere Selbstbeteiligung (SB) für Elementarschäden vereinbaren, müssen Sie im Schadenfall einen Teil der Kosten selbst bezahlen
       – aber nur bis zur Höhe der vereinbarten SB.</p>
      <p>Je höher die SB, desto geringer ist Ihr Beitrag.</p>
      <p><strong>Hinweis:</strong> Die hier ausgewählte SB gilt nur für Schäden durch Elementargefahren und gilt als Mindest-Selbst&shy;beteiligung. Wurde für 
      den gesamten Hausratvertrag eine höhere SB vereinbart, gilt diese auch für Elementarschäden.</p>`,
      glasversicherung_tt: `<h2>Glasversicherung</h2>
        <p>Wenn mit beantragt, dann umfasst der Versicherungsschutz der Haushalt-Glasversicherung: </p>
        <ul class="list-icn-checkbullet">
          <li>Gebäudeverglasungen von Fenstern, Türen, Balkonen, Terrassen, Wänden, Wintergärten, Veranden, Loggien, Wetterschutzvorbauten, 
          Dächern, Brüstungen, Duschkabinen, Lichtkuppeln, Sonnenkollektoren, Glasbausteinen, Profilbaugläsern, Kunststoffverglasungen.</li>
          <li>Mobiliarverglasungen von Bildern, Schränken, Vitrinen; Kunststoffverglasungen; Stand-, Wand- und Schrankspiegeln; Glasplatten; 
          Glasscheiben und Sichtfenster von Öfen, Elektro- und Gasgeräten; Aquarien/Terrarien; Glaskeramik-Kochflächen.</li>
        </ul>
        <p>Mitversichert sind bis jeweils 10.000&nbsp;€ je Schadenfall:</p>
        <ul class="list-icn-checkbullet">
          <li>Verglasungen von privat genutzten Kleingewächshäusern und Abdeckungen von Schwimmbecken</li>
          <li>Künstlerisch bearbeitete Glasscheiben, -spiegel und -platten</li>
          <li>Sonderkosten für Gerüste, Kräne und Beseitigung von Hindernissen</li>
          <li>Entschädigung für Anstriche, Malereien, Schriften, Verzierungen, Folien</li>
          <li>Schäden an Umrahmungen, Mauerwerk, Schutzeinrichtungen</li>
        </ul>`,
      naturgefahren_alert_gk0: '<p>Für Ihre Adresse können wir den Preis nicht exakt bestimmen. Hier ist eine persönliche Beratung notwendig. '
        + 'Bitte wenden Sie sich an Ihren Ansprechpartner <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort</a>.</p>',
      naturgefahren_alert_gk4: '<p>Ihre Adresse befindet sich in einem Risikogebiet. Hier ist eine persönliche Beratung notwendig. '
        + 'Bitte wenden Sie sich an Ihren Ansprechpartner <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort</a>.</p>',
      naturgefahren_alert_gk0_stat: '<p>Für Ihre Adresse können wir den Preis nicht exakt'
        + ' bestimmen. Es kann sein, dass Ihr '
        + 'Beitrag höher oder niedriger ausfällt. Hier erfolgt eine gesonderte Prüfung durch den Innendienst.</p>',
      naturgefahren_alert_gk4_stat: `
      <p>Das Elementarschadenrisiko dieser Wagnisanschrift ist möglicherweise sehr hoch. 
      Bitte wenden Sie sich zur Prüfung der Annahme und zur korrekten Beitragsberechnung an Ihre Fachabteilung.</p>
      `,
      notfalldienste: 'ServiceSchutzbrief Haus & Wohnung',
      notfalldienste_beschreibung: 'Wir zahlen Ihren Schlüsseldienst und andere Handwerkerrechnungen.',
      notfalldienste_tt: `<h2>ServiceSchutzbrief für Haus & Wohnung</h2>
        <p>Ihre Heizung ist kalt, Sie haben den Schlüssel verloren oder ein Wespenvolk hat sich auf Ihrem Balkon 
        einge&shy;nistet? Kleine Ärgernisse kosten viel Zeit, Geld und Nerven. 
        Mit dem ServiceSchutzbrief für Haus & Woh&shy;nung sind die Kosten für Notdienst- und Hand&shy;werk&shy;er&shy;leistungen 
        bei einem Notfall abgedeckt.</p>
        <p>Je Versicherungsfall erstatten wir bis zu 500&nbsp;€ und maximal 1.000&nbsp;€ für alle Versicherungsfälle im Jahr.</p>`,
      fahrraddiebstahl_tt: `<h2>Fahrraddiebstahl</h2>
        <p>Durch unseren Fahrraddiebstahl-Schutz können Sie Ihr Fahrrad, Fahrräder mit Elektromotor, die nicht der Zulassungspflicht 
        unterliegen sowie Fahrradanhänger ohne zeitliche Einschränkungen gegen Diebstahl mitversichern.
        Es spielt keine Rolle, wie teuer Ihr Fahrrad war, wir erstatten es Ihnen zum Neuwert ohne Summenbegrenzung, vorausgesetzt, dass es durch ein 
        verkehrsübliches Schloss gesichert war.</p>`,
    },
    sonderrabatt_tt: `<h2>Besondere Vereinbarungen</h2>
        <p>Es können bis zu 10% Sonderrabatt auf den aktuellen Verkaufstarif gewährt werden.
        Dieser Sonderrabatt kann ebenfalls in Kombination mit dem Staffelrabatt für junge Erwachsene vergeben werden.</p>
        <p>Der Abwerberabatt steht nur bei Abwerbegeschäft von anderen namhaften Serviceversicherern zur Verfügung.</p>
        <p>Dabei gelten folgende Einschränkungen:</p>
        <ul>
            <li>es müssen für den Kunden mindestens 3 aktive ÖVO-Verträge bestehen oder abgeschlossen werden (min. 50 EUR Beitrag p.a., kein Mofa-Kennzeichen)</li>
            <li>der Rabatt ist nur für Kunden und Risiken im ÖVO-Geschäftsgebiet möglich</li>
            <li>es dürfen keine Vorschäden vorhanden sein</li>
            <li>der Kunde muss eine gute Bonität aufweisen</li>
            <li>der Rabatt darf nur bei vergleichbarem Versicherungsumfang zum Vorvertrag vergeben werden</li>
            <li>es ist <strong>keine</strong> Kombination mit anderen (Staffel-)Rabatten möglich oder zulässig</li>
        </ul>
        <p><strong>Beide Rabatte werden nur auf das Hauptprodukt inklusive Haftungserweiterungen vergeben.
        Die Rabatte gelten daher nicht für eine etwaige Haushalt-Glasversicherung.</strong></p>`,

    links: {
      leistungsuebersichtLink: 'https://www.oeffentlicheoldenburg.de/hausrat_leistungsuebersicht',
      infoBlattLink: 'https://www.oeffentlicheoldenburg.de/hausrat_produktinformation',
      infoBlattGlasLink: 'https://www.oeffentlicheoldenburg.de/haushalt_glas_produktinformation',
      versBedingungenLink: 'https://www.oeffentlicheoldenburg.de/hausrat_versicherungsbedingungen',
      versBedingungenGlasLink: 'https://www.oeffentlicheoldenburg.de/haushalt_glas_versicherungsbedingungen',
    },
  },
  abschluss: {
    headline: 'Vielen Dank für Ihr Vertrauen!',
    ersterAbsatz: 'Wir freuen uns, dass Sie sich für unsere'
    + ' Hausratversicherung entschieden haben. Sobald Ihr Antrag bei uns eingegangen ist, senden wir Ihnen per E-Mail eine Bestätigung. Eine Unterschrift ist nicht mehr notwendig.',
    fragen: 'Sie haben Fragen? Gerne hilft Ihnen auch unser Vertragsservice unter der'
      + ' Telefonnummer $t(abschluss.telefon).',
  },
};

export default oevo;
